<template>
</template>
<script>
export default {
  name: 'Unique'
}
</script>